<span class="snackbar">
{{ data.message }}
  <img src="assets/images/popup.png" alt="Cart Popup">
</span>